import { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";

import Filter from "./Filter";
import Card from "../../common/TourItem";
import SignupModal from "./SignupModal";
import { FilterModal } from "admin-panel/tour-list/Modals";
import TourTab from "admin-panel/tour-list/TourTab";

import { searchTour, getFilterMax } from "../../services/adminTourList";
import { getTours } from "../../services/reservation";
import ReservationContext from "./ReservationContext";

export function ReserveLists() {
  const { reservations, getModalData } = useContext(ReservationContext);

  function prepareCard(data) {
    console.log(data);
    if (typeof data == "undefined") return;
    return data.map((value, index) => {
      let x = value.factor.total_amt - value.factor.total_paid;
      let res = [
        {
          title: "عنوان تور",
          description: value.tour.title,
        },
        {
          title: "نام خریدار",
          description: value.buyer.fullname,
        },
        {
          title: "تعداد ثبت نامی",
          description: value.factor.total_count,
        },
        {
          title: "مبلغ تور",
          description: value.tour.mainprice,
        },
        {
          title: "قیمت کل",
          description: value.factor.total_amt,
        },
        {
          title: "تاریخ",
          description: value.mtm,
        },
        {
          title: "مبلغ پرداخت شده",
          description: value.factor.total_paid,
        },
        {
          title: "مانده حساب",
          description: x > 0 ? x : 0,
        },
      ];
      res.concat(
        value.additionalCost.map((val) => {
          return {
            title: val.title,
            description: val.cost - val.discount,
          };
        })
      );
      return (
        <Card
          index={index}
          type="reserve"
          data={res}
          editHandler={() => getModalData(value.id)}
        ></Card>
      );
    });
  }

  return (
    <>
      <div
        class="tab-pane fade show active"
        id="active-tour-list"
        role="tabpanel"
        aria-labelledby="home-tab"
      >
        <Filter />
        {prepareCard(
          reservations?.filter((value) => value.tour.main_status == 4)
        )}
      </div>
      <div
        class="tab-pane fade"
        id="tour-list-history"
        role="tabpanel"
        aria-labelledby="profile-tab"
      >
        <Filter />
        {prepareCard(
          reservations?.filter((value) => value.tour.main_status == 2)
        )}
      </div>
    </>
  );
}

export function ToursTab() {
  const { tours, getInfo, maxPrice } = useContext(ReservationContext);
  const [priceOptions, setPriceOptions] = useState({
    max: 50000000,
    step: 500000,
  });
  const [filterInputs, setFilterInputs] = useState({
    title: "",
    priceRange: [0, 0],
    transferType: 0,
    duration: 0,
    stm: "",
    ftm: "",
  });

  async function search() {
    let conditions = await searchTour(filterInputs);
    getInfo(conditions);
  }

  useEffect(() => {
    setPriceOptions({ ...priceOptions, max: maxPrice });
    setFilterInputs({ ...filterInputs, priceRange: [0, maxPrice] });
  }, []);
  return (
    <>
      <div class="tab-pane fade" id="tours-tab">
        <TourTab tours={tours} reservation />
      </div>
      {ReactDOM.createPortal(
        <>
          <SignupModal />
          <FilterModal
            filterInputs={filterInputs}
            setFilterInputs={setFilterInputs}
            priceOptions={priceOptions}
            search={search}
          />
        </>,
        document.getElementsByClassName("modals")[0]
      )}
    </>
  );
}
